import Head from "next/head";
import Searchbar from "../components/searchbar/searchbar";
import { useRouter } from "next/router";
import PageFooter from "../components/footer/page-footer";
import PageNavbar from "../components/navbar/navbar";
import styles from './app.module.css';
import { NavBarMobile } from "../components/navbar-mobile/navbar-mobile";
import logoWhite from './../public/logo-wite-128.png';
import logoPink from './../public/logo-pink.png';
import CartHandler from '../utils/shopping-cart-handler';
import Cart from "../components/cart/cart";
export default function MyApp({ Component, pageProps }: {Component: any, pageProps: any}) {
  const router = useRouter();
  const handleClick = (event: any) => {
    event.stopPropagation();
    router.push('/');
  }
  if (typeof document !== 'undefined') {
    CartHandler.init(document);
  }


  return (
	
	<>
    <Head>
      <title>Kjøp billige sexleketøy online</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" /> 
      <meta name="keywords" content="Sexleketøy, billig, dildo, vibrator, womanizer, kondomer, analsex, bdsm, pegging, strapon"></meta>
      <meta name="description" content="Et stort utvalg av dildoer, vibratorer, womanizer og andre populære sexleketøy. Det beste stedet å finne kjente produkter til en god pris. Nøkkelen til et godt sexliv ligger i glede og nytelse." />
      <meta property="og:title" content="Kjøp billige sexleketøy online" key="og-title" />
      <meta property="og:description" content="Et stort utvalg av dildoer, vibratorer, womanizer og andre populære sexleketøy. Det beste stedet å finne kjente produkter til en god pris. Nøkkelen til et godt sexliv ligger i glede og nytelse." key="og-description" />
      <link rel="icon" type="image/png" href={logoPink.src} />
      <meta property="og:type" content="website" key="og-type" />
      <meta property="og:site_name" content="Billige Sexleker" />
      
      <link rel="icon" href="/favicon.ico" />
      <link rel="index" href="https://www.billigesexleker.no" />
      <script type="application/ld+json" dangerouslySetInnerHTML={
      {__html: `{
        "@context": "http://schema.org",
        "@type": "WebSite",
        "url": "https://www.billigesexleker.no/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.billigesexleker.no/sok?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }`}} />
  <script type="text/javascript" dangerouslySetInnerHTML={
    {__html:`
    var _TradeTrackerTagOptions = {
      t: 'a',
      s: '263403',
      chk: 'b8e924635ba8729b2014319a307b492d',
      overrideOptions: {}
    };

    (function() {var tt = document.createElement('script'), s = document.getElementsByTagName('script')[0]; tt.setAttribute('type', 'text/javascript'); tt.setAttribute('src', (document.location.protocol == 'https:' ? 'https' : 'https') + '://tm.tradetracker.net/tag?t=' + _TradeTrackerTagOptions.t + '&amp;s=' + _TradeTrackerTagOptions.s + '&amp;chk=' + _TradeTrackerTagOptions.chk); s.parentNode.insertBefore(tt, s);})();
    `}} />

    </Head>
    <div className={styles.headerWrapper}> 
      <header className={styles.header}>
          <div className={styles.headerInner}>
            <img src={logoWhite.src} alt="Billigesexleker logo" style={{height: '24px'}} />
            <div style={{lineHeight: '18px', marginLeft: '8px', width: '100%'}} onClick={handleClick}>
              <span style={{fontSize: '18px', fontWeight: 600}}>Billigesexleker.no</span><br/>
              <span style={{fontSize: '13px', fontFamily: 'sans-serif'}}> - Sexleketøy til en god pris!</span>
            </div>
            <div className="showInMobile showOnPad" style={{overflow: 'visible'}}><Cart /></div>
          </div>
        <PageNavbar/>
        <span className="hideInMobile hideOnPad"><Cart /></span>
      </header>
    </div>      
    <section className={styles.searchBarWrapper}>
        <Searchbar/>
    </section>
    <div className={router.pathname.toLowerCase().indexOf('sok') == -1 ? styles.mainWrapper : ''}>
      <Component {...pageProps} />
    </div>
    <NavBarMobile/>
    <PageFooter/> 
      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:opsz,wght@9..144,600;9..144,700&display=swap');

        :root {
          --ink: #261e26;
          --muted: #716773;
          --cream: #faf8fa;
          --paper: #ffffff;
          --plum: #4a2946;
          --plum-dark: #2f1d2d;
          --coral: #795271;
          --coral-dark: #61415b;
          --blush: #f1ecf2;
          --butter: #d9cddd;
          --line: #e4dee5;
          --shadow: 0 14px 38px rgba(74, 41, 70, 0.09);
        }
        
        html,
        body {
		      padding: 0;
		      margin: 0;
		      font-size: 16px;
          background: var(--cream);
          font-family: 'DM Sans', sans-serif;
		      color: var(--ink);
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;   
          scroll-behavior: smooth;       
        }
        h1, h2 {
          font-family: 'Fraunces', serif;
          line-height: 1.08;
          color: var(--plum);
        }
        h1 {
          font-size: clamp(2rem, 5vw, 3.5rem);
          letter-spacing: -0.04em;
        }
        h2 {
          font-size: clamp(1.65rem, 3vw, 2.5rem);
          letter-spacing: -0.025em;
        }
        h3, h4 {
          color: var(--plum);
        }
        a {
          color: var(--coral-dark);
          text-underline-offset: 3px;
        }
        button, input {
          font: inherit;
        }
        img {
          max-width: 100%;
        }          
        .pinkHeader {
          background: var(--coral);
          color: white;
          padding: 10px 14px;
          border-radius: 10px;
        }
        #__next {
          height: inherit;
        }
        * {
          box-sizing: border-box;
        }
        .showOnPad {
          display: none;
        }
        .hideInMobile {
          display: block;
        }
        .showInMobile {
          display: none;
        }          
        @media only screen and (max-width: 600px) {
          .hideInMobile {
            display: none;
          }
          .showInMobile {
            display: block;
            overflow: hidden;
            text-align: center;
          }            
        }
        @media only screen and (min-width: 600px) and (max-width: 1200px) {
          .hideOnPad {
            display: none;
          }
          .showOnPad {
            display: block;
          }          
        }      
        @media (prefers-reduced-motion: reduce) {
          html { scroll-behavior: auto; }
          *, *::before, *::after {
            animation-duration: 0.01ms !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>
    </>
  )
}
